<template>
  <div class="m-4">
    <h1 class="text-h1">Administration des badges</h1>
    <PPagination
      v-if="tagsStore.list.total > pageSize"
      :current-page="page"
      :total="tagsStore.list.total"
      :page-size="pageSize"
      @change="syncPagination"
      class="mb-1"
      size-selector-position="hidden"
    />
    <div class="flex mb-1 h-6">
      <AdminTagsForm v-model:updating="updating" @refresh="refresh" class="ml-auto" />
    </div>
    <PTable
      caption=""
      :table="table"
      v-model:selected="selected"
      :sort-by="sortBy"
      @update:sort-by="syncSortBy"
      @click:row="updating = $event"
    >
      <template #column.body="{ row }">
        <ul>
          <li v-for="(item, index) in row.body" :key="index">
            <OhVueIcon :name="dotIcon" scale="1.5" class="pt-1v" />
            {{ item }}
          </li>
        </ul>
      </template>

      <template #column.showInEmail="{ row }">
        <div
          :class="{
            'text-error': !row.showInEmail,
            'text-success': row.showInEmail,
          }"
        >
          {{ row.showInEmail ? "Oui" : "Non" }}
        </div>
      </template>

      <template #column.default="{ row }">
        <div
          :class="{
            'text-error': !row.default,
            'text-success': row.default,
          }"
        >
          {{ row.default ? "Oui" : "Non" }}
        </div>
      </template>
    </PTable>
    <PPagination
      v-if="tagsStore.list.total > pageSize"
      :current-page="page"
      :total="tagsStore.list.total"
      :page-size="pageSize"
      @change="syncPagination"
      class="mt-1"
    />
  </div>
</template>

<script setup lang="ts">
import {
  PTable,
  PPagination,
  usePastaAutoTable,
  type Nullable,
  type PastaTableColumnDefArgs,
  useIcons,
} from "@pasta/box-v2";
import { ref } from "vue";
import { useAdminTagsStore } from "./admin-tags.store";
import { BiDot } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";
import { useAuthStore } from "@pasta/front-auth-v2";
import { type LetterFileTagDto } from "../app/dto/letter-file-tag.dto";
import AdminTagsForm from "./admin-tags-form.vue";

interface Props {
  page: number;
  pageSize: number;
  urlSearchPattern?: string;
  sortBy?: string;
}

const props = withDefaults(defineProps<Props>(), {
  sortBy: "id",
  pageSize: 10,
});

const authStore = useAuthStore();

const tagsStore = useAdminTagsStore();

const [dotIcon] = useIcons(BiDot);
const updating = ref<Nullable<LetterFileTagDto>>(null);

const columns: PastaTableColumnDefArgs<LetterFileTagDto>[] = [
  { key: "id", label: "ID", sortable: true, weight: 1 },
  { key: "name", label: "Nom", sortable: true, weight: 1 },
  { key: "showInEmail", label: "Mail", sortable: true, weight: 1 },
  { key: "default", label: "Par défaut", sortable: true, weight: 1 },
];

const { table, refresh, syncPagination, syncSortBy, selected } = usePastaAutoTable({
  entityName: "LetterFileTag",
  props,
  store: tagsStore as any,
  tableDef: {
    columns,
    isClickable: (tag: LetterFileTagDto) => authStore.ability.can("update", tag),
  },
});
</script>
